import React from 'react'
import BambooHRCareers from 'components/Careers/BambooHrCareers'
import { StaticImage } from 'gatsby-plugin-image'


export default function Positions({data}) {
    const {positionsTitle} = data
    return (
        <div className='careers-position-wrap' id='open-positions'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <figure className='abt-origins-icon mb-4'>
                            <StaticImage src='../../../images/origins-icon.png' alt='image' />
                        </figure>
                        <h2 className='heading-level-2 blue-color'>{positionsTitle}</h2>
                    </div>

                    <div className='col-md-12'>
                        <BambooHRCareers />
                    </div>
                </div>
            </div>
        </div>
    )
}
